"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddedDocumentSchema = exports.ChunkedDocumentSchema = void 0;
const zod_1 = require("zod");
const document_specifications_1 = require("./document-specifications");
const chunks_1 = require("./chunks");
exports.ChunkedDocumentSchema = document_specifications_1.DocumentChunkingSpecificationSchema.extend({
    chunks: zod_1.z.array(chunks_1.ChunkContentSchema),
});
exports.EmbeddedDocumentSchema = document_specifications_1.DocumentEmbeddingSpecificationSchema.extend({
    chunks: zod_1.z.array(chunks_1.ChunkContentWithEmbeddingSchema),
});
//# sourceMappingURL=chunked-document.js.map